var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chat_left clearfix"},[_c('div',{staticClass:"chat_left_item_1"},[_vm._v("KIL_AI")]),_c('div',{staticClass:"chat_left_item_2"},[_c('div',{staticClass:"chat_left_time"},[_vm._v(_vm._s(_vm.dialogue.time))]),_c('div',{staticClass:"chat_left_content",domProps:{"innerHTML":_vm._s(_vm.compiledMarkdown)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }